import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b67b9f4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1b67b9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67b9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b67b9f4')) {
      api.createRecord('1b67b9f4', component.options)
    } else {
      api.reload('1b67b9f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1b67b9f4&scoped=true&", function () {
      api.rerender('1b67b9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingRadar/followUp/index.vue"
export default component.exports